import React, { useContext, useState, useEffect } from "react";
import { MusicContext } from "../Context/MusicContext";
import Image18 from "../Images/Image18.png";
import Image18_18 from "../Images/Image18-18.png";
import Star from "../Icons/Star.png";
import "../Styles/Page.css";

function Page18(){
  const { currentTimeRef, language, currentPage } = useContext(MusicContext);
  const [flipped, setFlipped] = useState(false);

  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate((n) => n + 1);
    }, 200); 
    return () => clearInterval(interval);
  }, []);

function stop(e){
    e.stopPropagation();
    e.preventDefault()
    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation){
      e.nativeEvent.stopImmediatePropagation();
    }
  };

   function handleToggle(e){
    e.stopPropagation();
    setFlipped((prev) => !prev);
  };
  
    const transcripts = {
      en: {
      paragraphs: [
  [
    { text: "“It grew?” said Khaya, surprised.", start: 0, end: 3.9 },
  ],
  [
    { text: "“Yes, it did!", start: 4, end: 5 },
    { text: "I knew it! I knew it would grow!” exclaimed Amile.", start: 5.1, end: 9.8 },
  ]
      ]
},
      zu: {
      paragraphs: [
  [
    { text: "“Sikhulile?” kusho uKhaya, emangele.", start: 0, end: 3.9 },
  ],
  [
    { text: "“Yebo, sikhulile!", start: 4, end: 5.6 },
    { text: "Bengazi! Bengazi ukuthi sizokhula!” kubabaza uAmile.", start: 5.7, end: 10.4 },
  ]
]
    }
};
    const { paragraphs } = transcripts[language];
    const currentTime = currentTimeRef.current;

  return(
    <section className="page">
    <section className="page-text">
      {paragraphs.map((para, pIndex) => (
        <p key={pIndex}>
          {para.map((line, i) => {
        const isActive = currentPage === 18 && currentTime >= line.start && currentTime <= line.end;
        return(
          <span key={i} className={isActive ? "highlight" : ""}>
            {line.text + " "}
          </span>
        );
      })}
      </p>
      ))}
      </section>
     <section className="image-wrapper" onClick={stop} onPointerDown={stop} onMouseDown={stop} onTouchStart={stop}>
     {flipped ? (
          <img src={Image18} alt="Page 18" className="page-image-18" />
        ) : (
          <img src={Image18_18} alt="Page 18" className="page-image-18-18" />
        )}

      <img src={Star} alt="Star" className="star-indicator" onClick={handleToggle} />
      </section>
      <section className="even">18</section>
    </section>
  );
}

export default Page18;